module.exports = __webpack_public_path__ + "static/media/32.38d1d377.jpg";